import gql from 'graphql-tag'

export const QUERY_GET_A_HUB_ANALYTICS_CONFIGURATION = gql`
  query AHubAnalyticsConfiguration($type: aHubAnalyticsConfigurationType!, $units: [String], $search: String) {
    aHubAnalyticsConfiguration(type: $type, units: $units, search: $search) {
      _id
      title
      filters {
        units {
          _id
          id_erp
          name
          cnpj
          __typename
        }
        __typename
      }
      createdAt
      __typename
    }
  }
`

export const QUERY_GET_A_HUB_ANALYTICS_CONFIGURATIONS = gql`
  query AHubAnalyticsConfigurations($type: aHubAnalyticsConfigurationType!) {
    aHubAnalyticsConfigurations(type: $type) {
      aHubAnalyticsConfigurations {
        _id
        createdAt
        default
        filters {
          clientsType
          offersScheduleIds
          products {
            _id
            name
            sku
          }
          units {
            _id
            id_erp
            name
          }
        }
        model
        notRecurrent {
          analyzedPeriod {
            finalDate
            initialDate
          }
          referencePeriod {
            finalDate
            initialDate
          }
        }
        recurrent {
          initialWeekDay
          modelType
        }
        status
        title
        type
      }
    }
  }
`

export const QUERY_GET_RFV_ANALYTICS_PERIOD = gql`
  query AHubAnalyticsPeriod($analyticConfigurationsId: [String]!, $search: String, $initialDate: String, $finalDate: String) {
    aHubAnalyticsPeriod(analyticConfigurationsId: $analyticConfigurationsId, search: $search, initialDate: $initialDate, finalDate: $finalDate) {
      _id
      title
      initialDate
      finalDate
      createdAt
      dynamic
    }
  }
`
export const QUERY_GET_ALL_RFV_ANALYTICS_PERIODS = gql`
  query AHubAnalyticsPeriods($analyticConfigurationsIds: [String]!, $removeDuplicates: Boolean) {
    aHubAnalyticsPeriods(analyticConfigurationsIds: $analyticConfigurationsIds, page: 1, pageSize: 9999, removeDuplicates: $removeDuplicates) {
      page
      records
      aHubAnalyticsPeriods {
        _id
        title
        initialDate
        finalDate
        createdAt
        dynamic
      }
    }
  }
`

export const QUERY_GET_RFV_CLIENTS_METRICS = gql`
  query RfvClientsMetrics($analyticConfigurationId: String!, $periodId: String!, $segments: [String]) {
    rfvClientsMetrics(analyticConfigurationId: $analyticConfigurationId, periodId: $periodId, segments: $segments) {
      champions {
        metrics {
          clients
          tickets
          recency
          revenue
          frequency
          averageTicket
          percentageRevenue
          percentageTickets
          monthlyAverageRevenuePerClient
          __typename
        }
        channels {
          sms
          email
          app
          whatsapp
          __typename
        }
        __typename
      }
      loyals {
        metrics {
          clients
          tickets
          recency
          revenue
          frequency
          averageTicket
          percentageRevenue
          percentageTickets
          monthlyAverageRevenuePerClient
          __typename
        }
        channels {
          sms
          email
          app
          whatsapp
          __typename
        }
        __typename
      }
      promising {
        metrics {
          clients
          tickets
          recency
          revenue
          frequency
          averageTicket
          percentageRevenue
          percentageTickets
          monthlyAverageRevenuePerClient
          __typename
        }
        channels {
          sms
          email
          app
          whatsapp
          __typename
        }
        __typename
      }
      atRisk {
        metrics {
          clients
          tickets
          recency
          revenue
          frequency
          averageTicket
          percentageRevenue
          percentageTickets
          monthlyAverageRevenuePerClient
          __typename
        }
        channels {
          sms
          email
          app
          whatsapp
          __typename
        }
        __typename
      }
      lowValue {
        metrics {
          clients
          tickets
          recency
          revenue
          frequency
          averageTicket
          percentageRevenue
          percentageTickets
          monthlyAverageRevenuePerClient
          __typename
        }
        channels {
          sms
          email
          app
          whatsapp
          __typename
        }
      }
      losses {
        metrics {
          clients
          tickets
          recency
          revenue
          frequency
          averageTicket
          percentageRevenue
          percentageTickets
          monthlyAverageRevenuePerClient
          __typename
        }
        channels {
          sms
          email
          app
          whatsapp
          __typename
        }
        __typename
      }
      neverBought {
        metrics {
          clients
          tickets
          recency
          revenue
          frequency
          averageTicket
          percentageRevenue
          percentageTickets
          monthlyAverageRevenuePerClient
          __typename
        }
        channels {
          sms
          email
          app
          whatsapp
          __typename
        }
        __typename
      }
    }
  }
`
export const QUERY_GET_RFV_PERIOD_MIGRATIONS = gql`
  query RfvPeriodMigrations(
    $referenceAnalyticConfigurationId: String!
    $analyzedAnalyticConfigurationId: String!
    $referencePeriodId: String!
    $analyzedPeriodId: String!
    $segments: [String]
  ) {
    rfvPeriodMigrations(
      reference: { analyticConfigurationId: $referenceAnalyticConfigurationId, periodId: $referencePeriodId }
      analyzed: { analyticConfigurationId: $analyzedAnalyticConfigurationId, periodId: $analyzedPeriodId }
      segments: $segments
    ) {
      champions {
        champions
        loyals
        promising
        atRisk
        lowValue
        losses
        neverBought
        __typename
      }
      loyals {
        champions
        loyals
        promising
        atRisk
        lowValue
        losses
        neverBought
        __typename
      }
      promising {
        champions
        loyals
        promising
        atRisk
        lowValue
        losses
        neverBought
        __typename
      }
      atRisk {
        champions
        loyals
        promising
        atRisk
        lowValue
        losses
        neverBought
        __typename
      }
      lowValue {
        champions
        loyals
        promising
        atRisk
        lowValue
        losses
        neverBought
        __typename
      }
      losses {
        champions
        loyals
        promising
        atRisk
        lowValue
        losses
        neverBought
        __typename
      }
      neverBought {
        champions
        loyals
        promising
        atRisk
        lowValue
        losses
        neverBought
        __typename
      }
      __typename
    }
  }
`
